import Joi from 'joi';
import { objectId } from '@/shared/validations/custom.validation';

export const amenitiesValidation = {
  get: Joi.object({
    id: Joi.string().custom(objectId).required(),
  }).unknown(true),
  query: Joi.object().unknown(true),

  create: Joi.object({
    name: Joi.string().trim().required(),
    icon: Joi.string().trim().required(),
    description: Joi.string().trim().allow('').optional(),
    createdBy: Joi.string().custom(objectId).optional(),
    updatedBy: Joi.string().custom(objectId).optional(),
  }),

  update: {
    params: Joi.object({
      id: Joi.string().custom(objectId).required(),
    }).unknown(true),
    body: Joi.object({
      name: Joi.string().trim().optional(),
      icon: Joi.string().trim().optional(),
      description: Joi.string().trim().allow('').optional(),
      updatedBy: Joi.string().custom(objectId).optional(),
    }),
  },

  delete: Joi.object({
    id: Joi.string().custom(objectId).required(),
  }),
};
